import { useDispatch, useSelector } from "react-redux"
import { userActions } from "../../../../../store/user-slice"

const Pagination = (props) => {

    let dispatch = useDispatch()
    const { index, users } = props
    let selectedpagination = useSelector(state => state.user.selectedpagination)

    return <button type='button' className={`w-auto mt-3 btn ${selectedpagination == index ? 'active' : ''}`} onClick={() => {
        dispatch(userActions.setFilteredItems(users))
        dispatch(userActions.setSelectedPagination(index))
    }}  >{index + 1}</button>


}

export default Pagination;